import {
  Calendar, CalendarDays, Check, ChevronDown, ChevronLeft, ChevronRight, Circle,
  Clock, Command, Copy, Download, GitBranch, Gauge, Github, Inbox, Laptop, Layers, Link2, Lock, Minus, Moon,
  Paperclip, Pencil, PieChart, Plus, RotateCcw, Search, Settings, Sparkles, Square,
  Star, Sun, Target, Trash2, User, X, AlertCircle, BarChart3, BedDouble, FileText, Info, Zap,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

const icons = {
  calendar: Calendar, calendarDays: CalendarDays, check: Check,
  chevronDown: ChevronDown, chevronLeft: ChevronLeft, chevronRight: ChevronRight,
  circle: Circle, clock: Clock, command: Command, focus: Target,
  git: GitBranch, gauge: Gauge, github: Github, inbox: Inbox, laptop: Laptop,
  layers: Layers, link: Link2, lock: Lock, minus: Minus, moon: Moon, paperclip: Paperclip,
  pencil: Pencil, pie: PieChart, plus: Plus, rotate: RotateCcw, search: Search,
  settings: Settings, sparkle: Sparkles, square: Square, star: Star, sun: Sun,
  target: Target, trash: Trash2, user: User, x: X, alert: AlertCircle,
  chart: BarChart3, bed: BedDouble, info: Info, zap: Zap,
  download: Download, copy: Copy, fileText: FileText,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof icons;

export function Icon({ name, size = 16, className }: { name: IconName; size?: number; className?: string }) {
  const C = icons[name];
  return <C size={size} strokeWidth={1.8} className={className} />;
}
